enum ProjectReportsFormats {
  EXCEL = "xlsx",
}

export { ProjectReportsFormats };
